var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4982 6.18541C23.3625 5.67482 23.0951 5.20883 22.7227 4.83407C22.3503 4.4593 21.8861 4.18891 21.3764 4.04996C19.5 3.54541 12 3.54541 12 3.54541C12 3.54541 4.5 3.54541 2.62364 4.04996C2.11393 4.18891 1.64966 4.4593 1.27729 4.83407C0.904916 5.20883 0.637506 5.67482 0.501818 6.18541C5.96046e-08 8.06996 0 12 0 12C0 12 5.96046e-08 15.93 0.501818 17.8145C0.637506 18.3251 0.904916 18.7911 1.27729 19.1658C1.64966 19.5406 2.11393 19.811 2.62364 19.95C4.5 20.4545 12 20.4545 12 20.4545C12 20.4545 19.5 20.4545 21.3764 19.95C21.8861 19.811 22.3503 19.5406 22.7227 19.1658C23.0951 18.7911 23.3625 18.3251 23.4982 17.8145C24 15.93 24 12 24 12C24 12 24 8.06996 23.4982 6.18541Z",
    fill: "#454747"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54541 15.5684V8.43115L15.8181 11.9998L9.54541 15.5684Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtubeIcon.b0de2414442bcfbf8e4a926105f078a6.svg";
export { ForwardRef as ReactComponent };